/** Read-only source-grounded guidance. */
export const helpCenterTour = {
    module: 'help_center',
    title: 'Help Center Tour',
    title_vi: 'Hướng dẫn Trung tâm hỗ trợ',
    description: 'Search help articles, narrow guidance by category and module, and open the material relevant to your work.',
    description_vi: 'Tìm bài trợ giúp, lọc theo danh mục và phân hệ, rồi mở tài liệu phù hợp với công việc.',
    estimated_duration_seconds: 112,
    revision: '2026-10-26.8',
    steps: [
        {
            step_id: 'explore_help',
            navigate_to: '/admin/help',
            target: '[data-testid="help-center-page"] [role="search"]',
            wait_for: '[data-testid="help-center-page"][data-tour-ready="true"] [role="search"]',
            title: 'Help Center',
            title_vi: 'Trung tâm trợ giúp',
            description: 'Use search, category and module filters to find guidance for the task and audience you need. Audience fit is explained by article context, not a separate audience selector. Read titles and badges before opening an article; a filtered no-match does not prove the whole library is empty. Playback opens no article or support request.',
            description_vi: 'Dùng tìm kiếm, danh mục và bộ lọc phân hệ để tìm hướng dẫn cho công việc và người đọc phù hợp. Ngữ cảnh bài viết giải thích đối tượng sử dụng, không có bộ lọc đối tượng riêng. Đọc tiêu đề và nhãn trước khi mở bài; không khớp bộ lọc chưa chứng minh toàn thư viện trống. Hướng dẫn không mở bài hoặc yêu cầu hỗ trợ.',
            position: 'bottom',
            duration_ms: 24000,
        },
        {
            step_id: 'help_search',
            navigate_to: '/admin/help',
            target: '[data-testid="help-search-input"]',
            title: 'Search for the task you need',
            title_vi: 'Tìm công việc cần thực hiện',
            description: 'Enter a feature or workflow term, then press Enter or Search to find relevant articles. Clear the search to return to browsing without a previous query narrowing the library.',
            description_vi: 'Nhập tên tính năng hoặc quy trình, rồi nhấn Enter hoặc Tìm kiếm để tìm bài viết phù hợp. Xóa tìm kiếm để quay lại duyệt thư viện mà không bị giới hạn bởi truy vấn trước đó.',
            wait_for: '[data-testid="help-center-page"][data-tour-ready="true"] [data-testid="help-search-input"]',
            position: 'bottom',
            duration_ms: 22000,
        },
        {
            step_id: 'help_category',
            navigate_to: '/admin/help',
            target: '[data-testid="categories-tab"]',
            title: 'Choose the kind of guidance',
            title_vi: 'Chọn loại hướng dẫn',
            description: 'Choose a category to narrow the library to the kind of guidance you need. Clear it to broaden the list again. An empty filtered list does not mean the documentation library is empty.',
            description_vi: 'Chọn danh mục để thu hẹp thư viện theo loại hướng dẫn cần đọc. Xóa lựa chọn để mở rộng danh sách. Danh sách sau lọc trống không có nghĩa là thư viện tài liệu trống.',
            wait_for: '[data-testid="help-center-page"][data-tour-ready="true"] [data-testid="categories-tab"]',
            position: 'bottom',
            duration_ms: 22000,
        },
        {
            step_id: 'help_module',
            navigate_to: '/admin/help',
            target: '[data-testid="module-help-tab"]',
            title: 'Find guidance for a module',
            title_vi: 'Tìm hướng dẫn cho một phân hệ',
            description: 'Choose a module to find its operating guidance. Category and module filters narrow the same library; clear them when changing the subject of your work.',
            description_vi: 'Chọn phân hệ để tìm hướng dẫn sử dụng. Bộ lọc danh mục và phân hệ thu hẹp cùng một thư viện; xóa bộ lọc khi chuyển sang công việc khác.',
            wait_for: '[data-testid="help-center-page"][data-tour-ready="true"] [data-testid="module-help-tab"]',
            position: 'bottom',
            duration_ms: 22000,
        },
        {
            step_id: 'help_read_articles',
            navigate_to: '/admin/help',
            target: '[data-testid="help-center-page"] :is(.ob-help-article-list-flex, .ob-help-empty-center)',
            title: 'Read titles and article context',
            title_vi: 'Đọc tiêu đề và ngữ cảnh bài viết',
            description: 'Check titles and category or module badges before opening an article. They distinguish workflow guidance from other reference material. If no articles match, change the search or clear filters before assuming guidance is unavailable.',
            description_vi: 'Đọc tiêu đề và nhãn danh mục hoặc phân hệ trước khi mở bài viết để phân biệt hướng dẫn quy trình với tài liệu tham khảo khác. Nếu không có bài phù hợp, đổi tìm kiếm hoặc xóa bộ lọc trước khi cho rằng không có hướng dẫn.',
            wait_for: '[data-testid="help-center-page"][data-tour-ready="true"] :is(.ob-help-article-list-flex, .ob-help-empty-center)',
            position: 'bottom',
            duration_ms: 22000,
        },
    ],
};
//# sourceMappingURL=help-center.js.map